import { Injectable } from '@nestjs/common';
import { ErrorResponse, GlobalResponseObject, LoginModel, LoginResponse } from '@schemax-whatsapp/shared-models';
import { User } from './entity/user.entity';
import { LoginRequest } from './model/login.request';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';

@Injectable()
export class UserService {
    constructor(
        @InjectRepository(User) private userRepo: Repository<User>, 
    ) { }

    /**
     * 
     * @param req 
     */
    async authorizeUser(req: LoginRequest): Promise<LoginResponse> {
        const username = req.username;
        const password = req.password;

        const userInfo = await this.userRepo.findOne({ where: { username: username, password: password, isActive: true}});
        if(!userInfo) {
            throw new ErrorResponse(0, 'Invalid credentials. Please login again');
        }
        const loginModel = new LoginModel(userInfo.username, userInfo.password, userInfo.id, userInfo.companyId, userInfo.role);
        return new LoginResponse(true, 0, 'User logged in', loginModel);
    }

    /**
     * 
     * @param req 
     * @returns 
     */
    async changeExistingPassword(req: LoginRequest): Promise<GlobalResponseObject> {
        const username = req.username;
        const password = req.password;

        const userInfo = await this.userRepo.findOne({ where: { username: username, isActive: true}});
        if(!userInfo) {
            throw new ErrorResponse(0, 'Username is not registered');
        }
        await this.userRepo.update({ username: username, isActive: true}, { password: password});

        return new GlobalResponseObject(true, 0, 'New password set successfully. Please Login with new password');
    }

}

